import { StateCreator } from 'zustand';

const initialState = {
  isUsingPaymentPortal: false,
};

export type PortalContextSlice = {
  isUsingPaymentPortal: boolean;
  setPortalContext: (isUsingPaymentPortal: boolean) => void;
};

export const createPortalContextSlice: StateCreator<PortalContextSlice, [], [], PortalContextSlice> = (set) => ({
  ...initialState,
  setPortalContext: (isUsingPaymentPortal) =>
    set(() => ({
      isUsingPaymentPortal,
    })),
});
